import React from 'react';
import { useWizard } from '../useWizard';
import ContactForm from '../forms/ContactForm';
import { WIZARD_STEPS } from '../../../types/wizard';

const ContactStep: React.FC = () => {
  const { state, stepErrors, updateContact } = useWizard();
  const errors = stepErrors[WIZARD_STEPS.CONTACT] || {};

  return (
    <div className="wizard-step">
      <h2>Primary Contact</h2>
      <p className="step-description">Optionally enter a primary contact for the clinic.</p>

      <ContactForm
        values={state.contact}
        onChange={updateContact}
        errors={errors}
      />
    </div>
  );
};

export default ContactStep;
